<div class="saved-free-selections">
    <div class="flex-row">
        <ng-container *ngrxLet="selectionName$ as currentSelectionName">
            <ng-container *ngrxLet="hasSavedSelections$ as hasSavedSelections">
                <button
                    (click)="downloadSelections()"
                    [disabled]="!hasSavedSelections"
                    class="icon-button"
                    [attr.aria-label]="'Download selections'"
                    [title]="
                        hasSavedSelections
                            ? 'Download all selections for dataset in JSON format'
                            : 'No data available for download'
                    "
                >
                    <cds-icon shape="download"></cds-icon>
                </button>
                <cds-select layout="vertical" controlWidth="stretch">
                    <label>Saved selections</label>
                    <select
                        name="free-selection"
                        class="free-selection-select"
                        [ngModel]="currentSelectionName"
                        (ngModelChange)="setSelection($event)"
                        [disabled]="!hasSavedSelections"
                    >
                        <option [ngValue]="undefined">Unsaved selection</option>
                        <ng-container *ngFor="let name of selectionNames$ | async">
                            <option [ngValue]="name">{{ name }}</option>
                        </ng-container>
                    </select>
                </cds-select>
                <ng-container *ngrxLet="isSharedCase$ as isSharedCase">
                    <cds-button
                        size="sm"
                        [disabled]="!currentSelectionName || isSharedCase"
                        (click)="saveSelection()"
                    >
                        Update
                    </cds-button>
                    <cds-button
                        size="sm"
                        action="outline"
                        [disabled]="isSharedCase"
                        (click)="saveSelectionAs()"
                    >
                        Create new
                    </cds-button>

                    <button
                        size="sm"
                        [disabled]="!currentSelectionName || isSharedCase"
                        (click)="deleteSelection(currentSelectionName)"
                        class="icon-button"
                    >
                        <cds-icon shape="trash"></cds-icon>
                    </button>
                </ng-container>
                <button class="wiki-btn" (click)="goToWiki()">?</button>
            </ng-container>
        </ng-container>
    </div>

    <cds-alert-group
        *ngIf="intensityMapsMismatchWarning$ | async as warning"
        status="warning"
        type="light"
        class="map-mismatch-alert"
    >
        <cds-alert>{{ warning }}</cds-alert>
    </cds-alert-group>
</div>
